import React from "react";
import {
    List,
    Datagrid,
    TextField,
    EditButton,
    TextInput,
    ShowButton,
    TopToolbar,
    CreateButton,
    ExportButton,
    FilterButton,
    BooleanField
} from 'react-admin';

const agentFilters = [
    <TextInput label="Id" source="id" name="Id" />,
    <TextInput label="role" source="role" name="Role" />
];

const ListActions = () => {
    return(
        <TopToolbar>
            <CreateButton />
            <FilterButton />
            <ExportButton />
        </TopToolbar>
    );
}

export const AdminAiSystemAgentToolList = () => {

    return (
        <List
            resource="tools"
            actions={ <ListActions /> }
            filters={ agentFilters }>
            {/* Off, like the other 43 lists. It was on here only because nothing said otherwise, and
                what it offered was a bulk delete with no confirmation and no permission check:
                `BulkDeleteButton` does not ask `canAccess`. Deleting one record at a time from
                its own form still works, and asks first. */}
            <Datagrid bulkActionButtons={ false }>
                <TextField source="id" />
                <TextField source="name" />
                <BooleanField source="enabled" />
                <>
                    <EditButton />
                </>
            </Datagrid>
        </List>
    );

}
